import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content p-4 w-100" }
const _hoisted_2 = { class: "card-title mt-0 mb-4" }
const _hoisted_3 = { class: "w-100 d-flex justify-content-between" }
const _hoisted_4 = { class: "w-75 ml-4" }
const _hoisted_5 = { class: "w-75 mr-4" }

import getDeliveryPlanVehicleInformation from '@/types/responses/getDeliveryPlanVehicleInformation';
import RegisterModal from '@/components/DailyReportEdit/Combine/RegisterModal.vue';
import combineDailyReportsResponse from 'src/types/responses/combineDailyReports';
import CompleteModal from '@/components/DailyReportEdit/Split/CompleteModal.vue';
import ButtonArea from '@/components/DailyReportEdit/Combine/ButtonArea.vue';
import RightPane from '@/components/DailyReportEdit/Combine/RightPane.vue';
import ArrowIcon from '@/components/DailyReportEdit/Combine/ArrowIcon.vue';
import LeftPane from '@/components/DailyReportEdit/Combine/LeftPane.vue';
import { useAuth } from '@/services/user/Auth0UserProvider';
import Api from '@/services/api/ApiServiceFabrick';
import DeliveryPlan from "@/types/DeliveryPlan";
import { useRouter } from 'vue-router';
import { ref, computed } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'CombineForm',
  props: {
    showFlash: { type: Function },
    deliveryPlan: {}
  },
  setup(__props: any) {

const props = __props;

const { loginWithRedirect } = useAuth();
const router = useRouter();
const selectedDeliveryPlans = ref<(DeliveryPlan | getDeliveryPlanVehicleInformation)[]>([props.deliveryPlan]);
const isOpenModal = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const isDisplayCompleteModal = ref<boolean>(false);
const hasError = ref<boolean>(false);

const isConfirmBtnDisabled = computed(() => {
  return selectedDeliveryPlans.value.length === 1 || hasError.value;
});

function execCombine() {
  isLoading.value = true;
  Api().combineDailyReports(props.deliveryPlan.delivery_plan_id, makeRequest()).then((data: combineDailyReportsResponse) => {
    if (data.status) {
      return isDisplayCompleteModal.value = true;
    }
    hasError.value = true;
    props.showFlash(i18n.global.t('pages.dailyReports.splitForm.failedMessage'), 'error', true);
  }).catch((error) => {
    errorHandler(error);
  }).finally(() => {
    isLoading.value = false;
  });
}

function makeRequest(): any {
  let deliveryPlanIds: string[] = [];
  selectedDeliveryPlans.value.forEach((plan) => {
    deliveryPlanIds.push(plan.delivery_plan_id);
  });

  return {
    combine_items: deliveryPlanIds
  }
}

function errorHandler(error: any) {
  const res = error.response
  switch (res.status) {
    case 401:
      loginWithRedirect({ appState: { targetUrl: location.pathname } })
      break
    case 403:
      hasError.value = true;
      props.showFlash(res.data.message, 'error', true);
      break
    case 422:
      hasError.value = true;
      props.showFlash(res.data.errors.delivery_plan_id.join(', '), 'error', true);
      break
  }
}

function moveDailyReportDisplay() {
  router.push({ name: "DailyReport" })
}

return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_card, { class: "p-4" }, {
        default: _withCtx(() => [
          _createElementVNode("h4", _hoisted_2, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.combineForm.title')), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(LeftPane, {
                modelValue: selectedDeliveryPlans.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDeliveryPlans).value = $event)),
                deliveryPlan: props.deliveryPlan
              }, null, 8, ["modelValue", "deliveryPlan"])
            ]),
            _createVNode(ArrowIcon),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(RightPane, {
                modelValue: selectedDeliveryPlans.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedDeliveryPlans).value = $event)),
                deliveryPlan: props.deliveryPlan
              }, null, 8, ["modelValue", "deliveryPlan"]),
              _createVNode(ButtonArea, {
                modelValue: isOpenModal.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isOpenModal).value = $event)),
                isDisabled: isConfirmBtnDisabled.value
              }, null, 8, ["modelValue", "isDisabled"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(RegisterModal, {
      modelValue: isOpenModal.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isOpenModal).value = $event)),
      title: _unref(i18n).global.t('pages.dailyReports.combineForm.registerModal.title'),
      combineItems: {
      driverName: props.deliveryPlan.driver.full_name,
      start: selectedDeliveryPlans.value[0].leaving_warehouse_date_time,
      end: selectedDeliveryPlans.value[selectedDeliveryPlans.value.length - 1].returning_warehouse_date_time,
    },
      execCombine: execCombine
    }, null, 8, ["modelValue", "title", "combineItems"]),
    _createVNode(CompleteModal, {
      modelValue: isDisplayCompleteModal.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isDisplayCompleteModal).value = $event)),
      messages: [
      _unref(i18n).global.t('pages.dailyReports.combineForm.completeModal.messageRow1'),
      _unref(i18n).global.t('pages.dailyReports.combineForm.completeModal.messageRow2')
    ],
      moveDailyReportDisplay: moveDailyReportDisplay
    }, null, 8, ["modelValue", "messages"])
  ], 64))
}
}

})